// src/Pages/ForgotPassword.js
import React, { useState, useEffect } from "react";
import { useSessionContext } from "@supabase/auth-helpers-react";

export default function ForgotPassword() {
  const { supabaseClient: supabase } = useSessionContext();

  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  useEffect(() => {
    if (!cooldown) return;
    const t = setInterval(() => setCooldown((s) => Math.max(0, s - 1)), 1000);
    return () => clearInterval(t);
  }, [cooldown]);

  const handleReset = async (e) => {
    e.preventDefault();
    if (loading || cooldown) return;

    setErr("");
    setMsg("");
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    setLoading(false);

    if (error) {
      console.error("[resetPasswordForEmail]", error);
      setErr(error.message || "Error sending recovery email");
    } else {
      setMsg("✅ Password reset link sent. Check your inbox.");
      setCooldown(60); // prevent rapid re-sends
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-black text-white">
      <form
        onSubmit={handleReset}
        className="w-full max-w-md bg-white/5 border border-white/20 rounded-2xl p-8 space-y-6"
      >
        <h2 className="text-2xl font-bold text-center">Forgot Password</h2>

        <input
          type="email"
          placeholder="Enter your email"
          className="w-full px-4 py-3 rounded-lg bg-white/10 border border-white/20 text-white"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button
          type="submit"
          disabled={loading || cooldown > 0}
          className={`w-full py-3 rounded-lg font-semibold transition ${
            loading || cooldown > 0
              ? "bg-purple-500/60 cursor-not-allowed"
              : "bg-purple-600 hover:bg-purple-700"
          }`}
        >
          {loading ? "Sending..." : cooldown > 0 ? `Resend in ${cooldown}s` : "Send Reset Link"}
        </button>

        {err && <p className="text-red-400 text-center text-sm">{err}</p>}
        {msg && <p className="text-green-400 text-center text-sm">{msg}</p>}
      </form>
    </div>
  );
}
